import { Modal } from '../ui/Modal';
import { useAuthStore } from '@/store/authStore';
import { SignInForm } from './SignInForm';
import { SignUpForm } from './SignUpForm';
import { ForgotPasswordForm } from './ForgotPasswordForm';

export function AuthModal() {
  const {
    showAuthModal,
    setShowAuthModal,
    authModalMode,
    setAuthModalMode
  } = useAuthStore();

  const handleClose = () => {
    setShowAuthModal(false);
  };

  const handleSuccess = () => {
    setShowAuthModal(false);
  };

  return (
    <Modal
      isOpen={showAuthModal}
      onClose={handleClose}
      size="md"
    >
      <div className="p-4 sm:p-6">
        {authModalMode === 'signin' && (
          <SignInForm
            onSuccess={handleSuccess}
            onSignUpClick={() => setAuthModalMode('signup')}
            onForgotPasswordClick={() => setAuthModalMode('forgot-password')}
          />
        )}

        {authModalMode === 'signup' && (
          <SignUpForm
            onSuccess={handleSuccess}
            onSignInClick={() => setAuthModalMode('signin')}
          />
        )}

        {authModalMode === 'forgot-password' && (
          <ForgotPasswordForm
            onBackToSignIn={() => setAuthModalMode('signin')}
            onSuccess={() => setAuthModalMode('signin')}
          />
        )}
      </div>
    </Modal>
  );
}